import { createFileRoute } from '@tanstack/react-router'
import { RuntimeDetailPage } from '@/features/runtimes/runtime-detail-page'
export const Route = createFileRoute('/_console/runtimes/$id')({ component: RuntimeDetailRoute })
function RuntimeDetailRoute() { const { id } = Route.useParams(); return <RuntimeDetailPage key={id} id={id} /> }
